<template>
    <div>
        <div>
            <progress-header />
        </div>
        <div class="container pt-2">
            <template v-if="isSending">
                <div class="col-4 offset-2 position-fixed d-flex align-items-center justify-content-center preloader-bg">
                    <div class="bg-white shadow p-5 text-center">
                        <div class="spinner-border">
                            <span class="sr-only">{{ $t('loading') }}...</span>
                        </div>

                        <div class="text-lg mt-2">
                            {{ $t('taxi.pages.summary.creating_order') }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <form @submit.prevent="handleSubmit">
                    <div class="row card shadow-sm mb-2" v-if="routeInfo !== null">
                        <div class="col-12">
                            <div class="text-lg  border-bottom py-3 mb-3">
                                {{ $t('coaches.summary.basic_information') }}
                            </div>

                            <div class="row border-bottom py-2">
                                <div class="col-4">
                                    <div class=" font-weight-bold">
                                        {{ $t('from') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ routeInfo.start_place }}
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class=" font-weight-bold">
                                        {{ $t('departure_date') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ routeInfo.departure_date }}
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class=" font-weight-bold">
                                        {{ $t('departure_time') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ routeInfo.departure_time }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2">
                                <div class="col-4">
                                    <div class=" font-weight-bold">
                                        {{ $t('to') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ routeInfo.end_place }}
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class=" font-weight-bold">
                                        {{ $t('return_date') }}
                                    </div>
                                    <div class=" font-weight-normal" v-if="!routeInfo.one_way">
                                        {{ routeInfo.return_date }}
                                    </div>
                                    <div class="font-weight-normal" v-else>
                                        -
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class=" font-weight-bold">
                                        {{ $t('return_time') }}
                                    </div>
                                    <div class=" font-weight-normal" v-if="!routeInfo.one_way">
                                        {{ routeInfo.return_time }}
                                    </div>
                                    <div class="font-weight-normal" v-else>
                                        -
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2 pb-4">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('passengers') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ routeInfo.passengers_number }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row card shadow-sm mb-2" v-if="routeInfo !== null">
                        <div class="col-12">
                            <div class="text-lg  border-bottom py-3 mb-3">
                                {{ $t('btm.summary.travel_options') }}
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptions.plane_option">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.travel_options.plane.is_plane_ticket_needed') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ $t('btm.travel_options.plane.' + travelOptions.plane_option) }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptions.transfer_option">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.travel_options.transfer.is_airport_transfer_needed') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ $t('btm.travel_options.transfer.' + travelOptions.transfer_option) }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptions.hotel_option.hotel_stars">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.travel_options.hotel.is_hotel_needed') }}
                                    </div>

                                    <div class="font-weight-normal">
                                        {{ $t('btm.travel_options.hotel.' + travelOptions.hotel_option.hotel_preference) }}, {{ travelOptions.hotel_option.hotel_stars }} {{ $t('btm.travel_options.hotel.stars') }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptions.insurance">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.travel_options.insurance.is_insurance_needed') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ $t('yes') }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptions.ferry_option.start_place">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.travel_options.ferry.is_ferry_ticket_needed') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ $t('from') }}: {{ travelOptions.ferry_option.start_place }}<br>
                                        {{ $t('to') }}: {{ travelOptions.ferry_option.end_place }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptions.train_option.start_place">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.travel_options.train.is_train_ticket_needed') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ $t('from') }}: {{ travelOptions.train_option.start_place }}<br>
                                        {{ $t('to') }}: {{ travelOptions.train_option.end_place }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptions.coach_option.start_place">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.travel_options.coach.is_coach_ticket_needed') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ $t('from') }}: {{ travelOptions.coach_option.start_place }}<br>
                                        {{ $t('to') }}: {{ travelOptions.coach_option.end_place }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptions.formal_assistance">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.travel_options.formal_assistance.is_formal_assistance_needed') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ $t('yes') }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptions.event_assistance">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.travel_options.event_assistance.is_event_needed') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ $t('yes') }}
                                    </div>
                                </div>
                            </div>

                            <div class="row border-bottom py-2" v-if="travelOptionComments">
                                <div class="col-12">
                                    <div class=" font-weight-bold">
                                        {{ $t('btm.comment') }}
                                    </div>
                                    <div class=" font-weight-normal">
                                        {{ travelOptionComments }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row card shadow-sm mb-2" v-if="contact !== null">
                        <div class="col-12 pb-4">
                            <div class="text-lg  border-bottom py-3 mb-3">
                                {{ $t('coaches.summary.contact_data') }}
                            </div>

                            <div>
                                <p>{{ $t('coaches.contact_data.name') }}: {{ contact.name }}</p>
                                <p v-if="contact.company_name">{{ $t('coaches.contact_data.company_name') }}: {{ contact.company_name }}</p>
                                <p v-if="contact.address">{{ $t('coaches.contact_data.address') }}: {{ contact.address }}</p>
                                <p v-if="contact.post_code">{{ $t('coaches.contact_data.post_code') }}: {{ contact.post_code }}</p>
                                <p v-if="contact.city">{{ $t('coaches.contact_data.city') }}: {{ contact.city }}</p>
                                <p v-if="contact.country">{{ $t('coaches.contact_data.country') }}: {{ contact.country }}</p>
                                <p v-if="contact.tax_number">{{ $t('coaches.contact_data.tax_number') }}: {{ contact.tax_number }}</p>
                                <p>{{ $t('coaches.contact_data.phone_number') }}: {{ contact.phone }}</p>
                                <p>{{ $t('coaches.contact_data.email') }}: {{ contact.email }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="row card shadow-sm mb-2">
                        <div class="col-12 pb-4">
                            <consents :consents.sync="consents"></consents>
                        </div>
                    </div>

                    <div class="row card shadow-sm mb-2" v-if="contact">
                        <div class="col-12 p-2">
                            <button type="submit" class="btn btn-primary w-100 py-2">
                                {{ $t('book') }}
                            </button>
                        </div>
                    </div>
                </form>
            </template>
        </div>
    </div>
</template>

<script>
    import ProgressHeader from './components/ProgressHeader';
    import { mapGetters } from 'vuex';
    import toastr from 'toastr';
    import BusinessTravelManagementRepository from '@repositories/BusinessTravelManagementRepository';
    import Consents from '@components/Consents';

    export default {
        components: {
            ProgressHeader,
            Consents,
        },
        data() {
            return {
                isSending: false,
                query: this.$route.query,

                agreements: {
                    rodo: false,
                    marketing: false,
                    data_processing: false,
                    mailing: false,
                },
                consents: null,
            };
        },

        computed: {
            ...mapGetters({
                routeInfo: 'businessTravelManagement/getRouteInfo',
                travelOptions: 'businessTravelManagement/getTravelOptions',
                travelOptionComments: 'businessTravelManagement/getTravelOptionComments',
                contact: 'businessTravelManagement/getContact',
                createAccount: 'businessTravelManagement/getCreateAccount',
                getUserId: 'user/getId',
            }),
        },

        methods: {
            handleSubmit() {
                this.isSending = true;
                let contact = {
                    ...contact,
                    data_processing: this.agreements.data_processing,
                    mailing: this.agreements.mailing,
                    marketing: this.agreements.marketing,
                };

                let checkedConsents = [];
                this.consents.forEach((consent) => {
                    if (consent.checked) {
                        checkedConsents.push(consent.id);
                    }
                });

                let data = {
                    route_info: this.routeInfo,
                    travel_options: this.travelOptions,
                    comments: this.travelOptionComments,
                    contact: this.contact,
                    checked_consents: checkedConsents,
                };

                data = {
                    ...data,
                    create_account: this.createAccount,
                    user_id: this.getUserId,
                };
                BusinessTravelManagementRepository.processOrder(data)
                    .then((response) => {
                        toastr.info(this.$t('btm.summary.order_created'), '', {timeOut: 0, extendedTimeOut: 0, positionClass: 'toast-middle-full-width'});
                    })
                    .then(() => {
                        this.$store.dispatch('businessTravelManagement/reset')
                            .then(() => {
                                this.$router.push({ name: 'home.index' });
                            });
                    })
                    .catch(() => {
                        toastr.error(this.$t('order_error'));
                        setTimeout(() => {
                            this.$router.push({ name: 'business-travel-management.index' });
                        }, 2000);
                    });
            },
        },
    };
</script>
